module.exports = __webpack_public_path__ + "6a6bbe069049f7d011167fae34590224.jpg";